/** hands the browser a file to save, e.g. a generated CSV */ export const downloadFile = (params)=>{
    const url = URL.createObjectURL(new Blob([
        params.content
    ], {
        type: params.type
    }));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = params.fileName;
    anchor.click();
    URL.revokeObjectURL(url);
};

//# sourceMappingURL=downloadFile.js.map